var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#CCCCCC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9196 22.3281C28.2935 17.9524 28.2935 10.8578 23.9196 6.48203C19.5457 2.10625 12.4543 2.10625 8.08039 6.48203C3.70652 10.8578 3.70652 17.9524 8.08039 22.3281L10.514 24.7263L13.7825 27.9025L13.9951 28.0909C15.2347 29.0956 17.05 29.033 18.2178 27.9028L22.1157 24.1108L23.9196 22.3281ZM16 19.2002C13.349 19.2002 11.2 17.0512 11.2 14.4002C11.2 11.7492 13.349 9.6002 16 9.6002C18.651 9.6002 20.8 11.7492 20.8 14.4002C20.8 17.0512 18.651 19.2002 16 19.2002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.475aead4.svg";
export { ForwardRef as ReactComponent };